import { ENVIRONMENT_URL } from '../constants';

export const isProd = () =>
  window.location.hostname.toLowerCase() === ENVIRONMENT_URL.PRODUCTION ||
  window.location.hostname.toLowerCase() === ENVIRONMENT_URL.MDA;
export const isSandbox = () => window.location.hostname.toLowerCase() === ENVIRONMENT_URL.SANDBOX;
export const isTest = () => window.location.hostname.toLowerCase() === ENVIRONMENT_URL.TEST;
export const isLocal = () => window.location.hostname.toLowerCase() === ENVIRONMENT_URL.LOCALHOST;
export const isVercelPreview = () => /\.vercel\.app$/i.test(window.location.hostname);
